"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PLAN_VERSIONS = exports.PLAN_SCOPES = void 0;
const PLAN_SCOPES = exports.PLAN_SCOPES = ['pro', 'premium'];
const PLAN_VERSIONS = exports.PLAN_VERSIONS = ['initial', 'Q3-2024'];